var Closable = /** @class */ (function () {
    function Closable(closeFn) {
        var _this = this;
        this._isClosed = false;
        this.subs = [];
        /** Can be used to subscribe to the element's closing */
        this.subscribe = function (fn) { return _this.subs.push(fn); };
        this._close = function () {
            closeFn();
            _this.subs.forEach(function (fn) { return fn(); });
            _this._isClosed = true;
            return true;
        };
    }
    Object.defineProperty(Closable.prototype, "close", {
        /** By calling this function, you can manually invoke the element's closing
         * @returns the close function assigned to this class
         */
        get: function () {
            return this._close;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Closable.prototype, "isClosed", {
        /** Can be used to check if the element has already been closed or not
         * @returns boolean
        */
        get: function () {
            return this._isClosed;
        },
        enumerable: false,
        configurable: true
    });
    return Closable;
}());
export { Closable };
